import cx from "classnames";
import React from "react";
import Tooltip from "./../../../wix-rich-content-common/lib/Tooltip.js";
import styles from "./ToolbarButton-scss.js";
const ToolbarButton = React.forwardRef(
  ({
    isMobile = false,
    active,
    disabled,
    tooltip,
    onClick,
    Icon,
    dataHook,
    label
  }, ref) => {
    const [showTooltip, setShowTooltip] = React.useState(false);
    return /* @__PURE__ */ React.createElement(
      Tooltip,
      {
        key: tooltip,
        content: tooltip,
        tooltipOffset: { x: 0, y: -8 },
        forceVisibility: showTooltip
      },
      /* @__PURE__ */ React.createElement(
        "button",
        {
          ref,
          className: cx(styles.toolbarButtonWrapper, {
            [styles.mobileToolbarButtonWrapper]: isMobile,
            [styles.active]: active,
            [styles.disabled]: disabled
          }),
          onClick: !disabled ? onClick : void 0,
          onMouseDown: (e) => e.preventDefault(),
          "data-hook": dataHook,
          disabled,
          type: "button",
          onFocus: () => setShowTooltip(true),
          onBlur: () => setShowTooltip(false)
        },
        /* @__PURE__ */ React.createElement("div", { className: cx(styles.iconTextWrapper, { [styles.mobileToolbarButton]: isMobile }) }, /* @__PURE__ */ React.createElement(Icon, null), label && /* @__PURE__ */ React.createElement("div", null, label))
      )
    );
  }
);
var ToolbarButton_default = ToolbarButton;
export {
  ToolbarButton_default as default
};
//# sourceMappingURL=ToolbarButton.js.map
